/**
 * 節慶特效配置
 * 每個節慶定義：
 * - id: 唯一識別碼
 * - name: 名稱
 * - checkActive: 判斷是否在節慶期間的函數
 */

export const SEASONAL_EFFECTS = {
  MID_AUTUMN: {
    id: 'mid_autumn',
    name: '中秋節',
    checkActive: (now) => {
      const month = now.getMonth() + 1;
      const day = now.getDate();

      // 9/26 ~ 9/28
      return month === 9 && day >= 26 && day <= 28;
    }
  },
  DOUBLE_TEN: {
    id: 'double_ten',
    name: '雙十節',
    checkActive: (now) => {
      const month = now.getMonth() + 1;
      const day = now.getDate();

      // 10/8 ~ 10/11
      return month === 10 && day >= 8 && day <= 11;
    }
  },
  CHRISTMAS: {
    id: 'christmas',
    name: '聖誕節',
    checkActive: (now) => {
      const month = now.getMonth() + 1; // 1-12
      const day = now.getDate();
      
      // 12/20 ~ 12/26
      return month === 12 && day >= 20 && day <= 26;
    }
  },
  NEW_YEAR: {
    id: 'new_year',
    name: '跨年',
    checkActive: (now) => {
      const month = now.getMonth() + 1;
      const day = now.getDate();
      
      // 12/29 ~ 12/31
      return month === 12 && day >= 29 && day <= 31;
    }
  },
  SPRING_FESTIVAL: {
    id: 'spring_festival',
    name: '春節',
    checkActive: (now) => {
      const month = now.getMonth() + 1;
      const day = now.getDate();
      
      // 1/29 ~ 2/22
      return (month === 1 && day >= 29) || (month === 2 && day <= 22);
    }
  }
};

/**
 * 取得當前應該顯示的節慶特效
 * @returns {string|null} 節慶 ID 或 null
 */
export const getCurrentSeasonalEffect = () => {
  const now = new Date();
  
  // 優先級：春節 > 跨年 > 聖誕節 > 中秋 > 雙十(日期不重疊,順序僅為保險)
  if (SEASONAL_EFFECTS.SPRING_FESTIVAL.checkActive(now)) {
    return SEASONAL_EFFECTS.SPRING_FESTIVAL.id;
  }
  
  if (SEASONAL_EFFECTS.NEW_YEAR.checkActive(now)) {
    return SEASONAL_EFFECTS.NEW_YEAR.id;
  }
  
  if (SEASONAL_EFFECTS.CHRISTMAS.checkActive(now)) {
    return SEASONAL_EFFECTS.CHRISTMAS.id;
  }

  if (SEASONAL_EFFECTS.MID_AUTUMN.checkActive(now)) {
    return SEASONAL_EFFECTS.MID_AUTUMN.id;
  }

  if (SEASONAL_EFFECTS.DOUBLE_TEN.checkActive(now)) {
    return SEASONAL_EFFECTS.DOUBLE_TEN.id;
  }
  
  return null;
};

